/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { DetailsModal } from './DetailsModal'

type Props = {
    className: string,
    parentToChild?: any[]
}

const LegalInquiriesTable: React.FC<Props> = ({ parentToChild, className }) => {
    const [selectedItem, setSelectedItem] = useState<any | null>(null);
    const [selectedIndex, setSelectedIndex] = useState<number | null>();
    const intl = useIntl();
    return (
        <div className={`card ${className}`} style={{ width: "100%", position: "relative", backgroundColor: "InfoBackground", alignSelf: "center" }}>



            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='text-dark fw-bolder text-hover-primary fs-6'>{intl.formatMessage({ id: 'LEGALINQUIRY.RESULTS' })}</span>
                </h3>
            </div>
            <div className='card-body py-3' >

                <div className='table-responsive'>

                    <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3' >

                        <thead>
                            <tr className='fw-bolder text-dark'>
                                <th className="text-left">RB</th>
                                <th className="text-left">Naziv pravnog za koje je rađen izvod</th>
                                <th className="text-left">Datum izdavanja izvoda</th>
                                <th className="text-left">Broj protokola</th>
                                <th className="text-left">Naziv podnosioca zahtjeva</th>
                                <th className="text-left">Da li je naplativ</th>
                                <th className="text-left">Korisnik koji je radio izvod</th>
                                <th className="text-left">Tip izvoda</th>

                            </tr>
                        </thead>

                        <tbody>
                            {parentToChild!.map((o, i) => <tr key={o.id}>
                                <td width="2%">
                                    <span title="Redni broj" >
                                        {i + 1}
                                    </span>
                                </td>
                                <td width="20%">
                                    <span title="Naziv pravnog lica za koje je rađen izvod" >
                                        {o.EntityName ? o.EntityName : o.entityName ? o.entityName : JSON.parse(o.body).count !== 0 ? JSON.parse(o.body).resultList[0].businessEntityName : ''}
                                    </span>
                                </td>
                                <td width="12%">
                                    <span title="Datum izdavanja izvoda" >
                                        {o.requestDateTime == null ? '' : o.requestDateTime.substring(8, 10) + '.' + o.requestDateTime.substring(5, 7) + '.' + o.requestDateTime.substring(0, 4) + '. ' + o.requestDateTime.substring(11, 19)}
                                    </span>
                                </td>
                                <td width="15%">
                                    <span title="Broj protokola" >
                                        {o.issuerDocumentId == null ? '' : o.issuerDocumentId}
                                    </span>
                                </td>
                                <td width="20%">
                                    <span title="Naziv podnosioca zahtjeva" >
                                        {o.requesteeFullName == null ? '' : o.requesteeFullName}
                                    </span>
                                </td>
                                <td className="text-left" width="5%">
                                    {o.chargible == true ? (
                                        <span className='correct'>✔</span>
                                    ) : (
                                        <span className='incorrect'>✖</span>
                                    )}
                                </td>
                                {/* <td className="text-left" width="10%">
                                    {o.payerName == null ? '' : o.payerName}
                                </td>
                                <td className="text-left" width="10%">
                                    {o.payingDate == null ? '' : o.payingDate.substring(8, 10) + '.' + o.payingDate.substring(5, 7) + '.' + o.payingDate.substring(0, 4) + '.'}
                                </td>*/}
                                <td className="text-left" width="10%">
                                    {o.userName == null ? '' : o.userName}
                                </td>
                                <td className="text-left" width="10%">
                                    {o.typeOfExport == null ? '' : o.typeOfExport}
                                </td>
                                <td>
                                    <button className='iconButton'
                                        title={`Prikaži detalje za redni broj ${i}`}
                                        aria-label={`Prikaži detalje za ${o.fullName}`}
                                        onClick={() => { console.log('CLICK', o); setSelectedItem(o); setSelectedIndex(i + 1); console.log('selectedItem:', selectedItem); }}
                                    >
                                        ℹ️
                                    </button>
                                </td>

                            </tr>)}
                        </tbody>

                    </table>
                    <DetailsModal
                        item={selectedItem}
                        index={selectedIndex}
                        onClose={() => setSelectedItem(null)}
                    />
                </div>

            </div>

        </div>
    )
}

export { LegalInquiriesTable }
